import React, { useState } from 'react';
import PropTypes from 'prop-types';
import StudentSelector from './StudentSelector';
import { apiFetch } from '../../../utils';
import { duckify } from '../../../utils/duckify';
import { flashMessages, modals } from '../../../ducks';

const MoreInfo = ({ customerId, moreInfoUrl, submitInquiry, hideModal, flash }) => {
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const handleMoreInfo = () => {
    setSubmitting(true);
    window.open(moreInfoUrl, '_blank');
    submitInquiry(customerId, selectedStudents).then(hideModal).catch(response => {
      flash({ message: 'Submit failed', type: 'danger' });
      setSubmitting(false);
    });
  };
  return (
    <StudentSelector
      multiSelect
      selectedStudents={selectedStudents}
      setSelectedStudents={setSelectedStudents}
      description='Select student(s) interested in more information'
      buttons={[
        (
          <button
            disabled={selectedStudents.length === 0 || submitting}
            type='button'
            className='btn btn-primary'
            onClick={handleMoreInfo}
          >
            Submit
          </button>
        )
      ]}
      title='More Info'
    />
  );
};
MoreInfo.propTypes = {
  customerId: PropTypes.string.isRequired,
  moreInfoUrl: PropTypes.string.isRequired
};

const mapDispatchToProps = (dispatch) => ({
  submitInquiry: (customerId, selectedStudents) => dispatch(
    (dispatch, getState) => {
      const path = 'sso_jwt/submit_shared_portal_inquiry';
      return apiFetch.post(getState(), path, {
        school_id: customerId,
        students: selectedStudents
      });
    }
  ),
  hideModal: () => dispatch(modals.actions.hide()),
  flash: (props) => dispatch(flashMessages.actions.show(props))
});

export default duckify(() => ({}), () => ({}), mapDispatchToProps)(MoreInfo);
